import React from 'react';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import { createStyles } from '@material-ui/core/styles';
import { Grid, Typography, IconButton, Link, Box, Dialog, InputAdornment, FormLabel } from '@material-ui/core/';
import {
  AccessTime, Add, AddCircle, Link as LinkIcon, Description
} from '@material-ui/icons/';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';

// core components
import Button from '../../../components/CustomButtons/Button';
import Table from '../../../components/Table/Table';
import Card from '../../../components/Card/Card';
import CardHeader from '../../../components/Card/CardHeader';
import CardBody from '../../../components/Card/CardBody';
import CustomInput from '../../../components/CustomInput/CustomInput';

import DefaultPerson from '../../../assets/img/person-icon.png';
import MockMap from '../../../assets/img/map-sample.png';
import ImageDropZone from '../../../components/ImageDropZone';
import { ActionLog, PersonImg, WorkLinkIcon } from './styled';

const styles = createStyles({
  cardCategoryWhite: {
    '&,& a,& a:hover,& a:focus': {
      color: 'rgba(255,255,255,.62)',
      margin: '0',
      fontSize: '14px',
      marginTop: '0',
      marginBottom: '0'
    },
    '& a,& a:hover,& a:focus': {
      color: '#FFFFFF'
    }
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: 300,
    fontFamily: '\'Roboto\', \'Helvetica\', \'Arial\', sans-serif',
    marginBottom: '3px',
    textDecoration: 'none',
    '& small': {
      color: '#777',
      fontSize: '65%',
      fontWeight: 400,
      lineHeight: 1
    }
  }
});

function WorkOrderDetail(props: any) {
  const { classes } = props;

  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const FormDialog = (
    <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="create-work-order">Create work order</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Grid container justify="center" alignItems="center" spacing={2}>
            <Grid item xs={6}>
              <CustomInput
                id="asset-id"
                labelText="Asset ID"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="asset-type"
                labelText="Asset Type"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="asset-location"
                labelText="Asset Location"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="asset-model"
                labelText="Asset Model"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <CustomInput
                id="work-description"
                multiline
                rowsMax={4}
                labelText="Work description"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="work-schedule"
                labelText="Work schedule"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="repeating-schedule"
                labelText="Repeating schedule"
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="estimate-completion-time"
                labelText="Estimated completion time"
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormLabel>Priority </FormLabel>
              <ToggleButtonGroup
                size="small"
                exclusive
                aria-label="text alignment"
              >
                <ToggleButton value="None" aria-label="none">
                  None
                </ToggleButton>
                <ToggleButton value="low" aria-label="low">
                  Low
                </ToggleButton>
                <ToggleButton value="medium" aria-label="medium">
                  Medium
                </ToggleButton>
                <ToggleButton value="high" aria-label="high">
                  High
                </ToggleButton>
              </ToggleButtonGroup>
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="estimate-completion-time"
                labelText="Estimated completion time"
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="work-schedule"
                labelText="Work schedule"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="assigned-to"
                labelText="Assigned To"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="assigned-team"
                labelText="Assigned Team"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <ImageDropZone />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="addtional"
                labelText="Add Additional"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <div>
                <input style={{ display: 'none' }} accept="*" className={classes.input} id="button-additional-file" type="file" />
                <label htmlFor="button-additional-file">
                  <FormLabel style={{ marginRight: "4px" }}>Additional files</FormLabel>
                  <IconButton size="small" color="primary" aria-label="upload picture" component="span">
                    <AddCircle />
                  </IconButton>
                </label>
              </div>
              <div>
                <label htmlFor="additional-task">
                  <FormLabel style={{ marginRight: "4px" }}>Additional tasks</FormLabel>
                  <IconButton size="small" color="primary" aria-label="additional task" component="span">
                    <AddCircle />
                  </IconButton>
                </label>
              </div>
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="approver"
                labelText="Approver"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleClose} color="primary">
          Create Maintain WO
        </Button>
      </DialogActions>
    </Dialog>
  );

  return (
    <Grid container>
      <Grid item xs={9} sm={9} md={9}>
        <Card>
          <CardHeader color="primary">
            <Grid container>
              <Grid container item xs={8} alignContent="center">
                <h4 className={classes.cardTitleWhite}>Work Order list</h4>
              </Grid>
              <Grid container item xs={4} justify="flex-end">
                <Button color="secondary" onClick={handleOpen}><Add />Create Work Order</Button>
              </Grid>
            </Grid>
          </CardHeader>
          <CardBody>
            <Grid container justify="center" alignContent="center" alignItems="center">
              <Grid container item xs={7}>
                <Grid item xs={4} sm={4} md={4}>
                  <Box marginBottom="16px" marginTop="16px">
                    <Typography variant="body2">
                      Work Order Number
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={8} sm={8} md={8}>
                  <Box marginBottom="16px" marginTop="16px">
                    <Typography variant="body2">
                      #123  <Link><WorkLinkIcon><LinkIcon fontSize="inherit" /> Link Work Order</WorkLinkIcon></Link>
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={4} sm={4} md={4}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      Asset Name
                  </Typography>
                  </Box>
                </Grid>
                <Grid item xs={8} sm={8} md={8}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      HYAC COMPRESSOR
                  </Typography>
                  </Box>
                </Grid>
                <Grid item xs={4} sm={4} md={4}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      Asset Model
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={8} sm={8} md={8}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      Copeland Scroll - Z2SDKR3D-PFJ-533
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={4} sm={4} md={4}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      Description
                  </Typography>
                  </Box>
                </Grid>
                <Grid item xs={8} sm={8} md={8}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      During routine check inlet airflow has been identified as being highly noisy. Likely chance the motor is about to sieze.
                  </Typography>
                  </Box>
                </Grid>
              </Grid>
              <Grid container item xs={5}>
                <Grid item xs={5} sm={5} md={5}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      Assign To
                  </Typography>
                  </Box>
                </Grid>
                <Grid item xs={7} sm={7} md={7}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      <Link>Lee King</Link>
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={5} sm={5} md={5}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      Team Member
                  </Typography>
                  </Box>
                </Grid>
                <Grid item xs={7} sm={7} md={7}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      <Link style={{ marginRight: "8px" }}>Lee King</Link>
                      <Link style={{ marginRight: "8px" }}>Oscar Wild</Link>
                      <Link>Phil John</Link>
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={5} sm={5} md={5}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      Additional Team
                  </Typography>
                  </Box>
                </Grid>
                <Grid item xs={7} sm={7} md={7}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      Alan Philip
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={5} sm={5} md={5}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      WO Status
                  </Typography>
                  </Box>
                </Grid>
                <Grid item xs={7} sm={7} md={7}>
                  <Box marginBottom="16px">
                    <Typography variant="body2" style={{ color: "green" }}>
                      In Progress
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={5} sm={5} md={5}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      Timer
                  </Typography>
                  </Box>
                </Grid>
                <Grid item xs={7} sm={7} md={7}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      <AccessTime fontSize="inherit" /> 12:00:12
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={7}>
                <Box marginTop="48px">
                  <div id="task_list">
                    <Grid container>
                      <Grid container item justify="flex-start" alignItems="center" xs={5}>
                        <Typography variant="subtitle1">TASKLIST</Typography>
                      </Grid>
                      <Grid container item justify="flex-end" alignItems="center" xs={7}>
                        <span style={{ marginRight: "16px" }}>Total Parts: 22</span> <span>Part cost: £ 292 </span>
                      </Grid>
                    </Grid>
                    <Table
                      tableHeaderColor="primary"
                      tableHead={['No.', 'Task Description', 'Task Type', 'Attachments']}
                      tableData={[
                        ['1', 'Cooling Tower', '234124', <Link><Description fontSize="small" /></Link>],
                        ['2', 'Hammer', '197829', <Link><Description fontSize="small" /></Link>],
                      ]}
                    />
                    <div style={{ marginTop: "8px", textAlign: "right" }}>
                      <IconButton size="small" color="primary" aria-label="add parts" component="div">
                        <AddCircle /><span style={{ marginLeft: "8px" }}>Add Task</span>
                      </IconButton>
                    </div>
                  </div>
                </Box>
                <Box marginTop="48px">
                  <div id="part">
                    <Grid container>
                      <Grid container item justify="flex-start" alignItems="center" xs={5}>
                        <Typography variant="subtitle1">PARTSLIST</Typography>
                      </Grid>
                      <Grid container item justify="flex-end" alignItems="center" xs={7}>
                        <span style={{ marginRight: "16px" }}>Total Parts: 22</span> <span>Part cost: £ 292 </span>
                      </Grid>
                    </Grid>
                    <Table
                      tableHeaderColor="primary"
                      tableHead={['No.', 'Part Description', 'Part Number', 'Units', 'Price']}
                      tableData={[
                        ['1', 'Cooling Tower', '234124', '1', '190.86'],
                        ['2', 'Hammer', '197829', '21', '78.55'],
                      ]}
                    />
                    <div style={{ marginTop: "8px", textAlign: "right" }}>
                      <IconButton size="small" color="primary" aria-label="add parts" component="div">
                        <AddCircle /><span style={{ marginLeft: "8px" }}>Add Parts</span>
                      </IconButton>
                    </div>
                  </div>
                </Box>
                <Box marginTop="24px">
                  <div id="additional_cost">
                    <Grid container>
                      <Grid container item justify="flex-start" alignItems="center" xs={5}>
                        <Typography variant="subtitle1">ADDITIONAL COST</Typography>
                      </Grid>
                      <Grid container item justify="flex-end" alignItems="center" xs={7}>
                        <span style={{ marginRight: "8px" }}>Additional Cost: 221.30</span> <span>Total cost: £ 292 </span>
                      </Grid>
                    </Grid>
                    <Table
                      tableHeaderColor="primary"
                      tableHead={['No.', 'Cost Name']}
                      tableData={[
                        ['1', 'Cooling Tower'],
                        ['2', 'Hammer'],
                      ]}
                    />
                    <div style={{ marginTop: "8px", textAlign: "right" }}>
                      <IconButton size="small" color="primary" aria-label="add cost" component="div">
                        <AddCircle /><span style={{ marginLeft: "8px" }}>Add Cost</span>
                      </IconButton>
                    </div>
                  </div>
                </Box>
                <Box marginTop="24px">
                  <div id="additional_file">
                    <Typography variant="subtitle1">ADDITIONAL FILES</Typography>
                    <Table
                      tableHeaderColor="primary"
                      tableHead={['No.', 'File Name']}
                      tableData={[
                        ['1', 'File name'],
                        ['2', 'Hammer'],
                      ]}
                    />
                    <div style={{ marginTop: "8px", textAlign: "right" }}>
                      <IconButton size="small" color="primary" aria-label="add files" component="div">
                        <AddCircle /><span style={{ marginLeft: "8px" }}>Add Files</span>
                      </IconButton>
                    </div>
                  </div>
                </Box>
              </Grid>
              <Grid item xs={5}>
                <Box marginTop="48px" marginLeft="24px">
                  <Typography variant="subtitle1">ASSET LOCATION</Typography>
                  <img alt="map information" src={MockMap} width="100%" />
                </Box>
              </Grid>
            </Grid>
          </CardBody>
        </Card>
      </Grid>
      <Grid item xs={3} sm={3} md={3}>
        <Box height="100%">
          <Card>
            <CardBody>
              <h4>History</h4>
              <ActionLog>
                <PersonImg src={DefaultPerson} />
                <Typography variant="body2">Greg lawson update order requirement</Typography>
              </ActionLog>
              <ActionLog>
                <PersonImg src={DefaultPerson} />
                <Typography variant="body2">Greg lawson update order requirement</Typography>
              </ActionLog>
              <ActionLog>
                <PersonImg src={DefaultPerson} />
                <Typography variant="body2">Greg lawson update order requirement</Typography>
              </ActionLog>
              <ActionLog>
                <PersonImg src={DefaultPerson} />
                <Typography variant="body2">Greg lawson update order requirement</Typography>
              </ActionLog>
            </CardBody>
          </Card>
        </Box>
      </Grid>
      {FormDialog}
    </Grid >
  );
}

export default withStyles(styles)(WorkOrderDetail);
